import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import GenericStepper from '../../../../../global/components/navigation/generic-stepper';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { AnnualEnrollmentContext, AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';
import { NewHireProps } from '../../../models/arc-epi-props';
import { NewHireEnrollmentStep } from '../../new-hire-enrollment/models/new-hire-enrollment-models';
import { setCurrentNewHireEnrollmentStep } from '../../new-hire-enrollment/slice/new-hire-enrollment-slices';
import { NewHireStep } from '../../new-hire/models/new-hire-model';
import { CreateNewParticipantForm } from './create-new-participant-form';
import { getNewParticipantStepItems } from './helper/new-participant-helper';
import { PersonSearchContext, PersonSearchKeys } from '../../person-search/person-search-model';
import { OSCRRService } from '../../person-search/oscrr-helpers';
import { BaseApiState } from '../../../../../global/models/api-model';
import { NewHireState } from '../../new-hire/models/new-hire-state-model';




function NewParticipantRecord() {

	const routeMatch = useRouteMatch();
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);
	const dispatch = useDispatch();
	const newHireState = useSelector<TcsmStates, NewHireState>(state => state.newHireState);
	const currentStep = newHireState?.currentStep;
	const apiState = useSelector<TcsmStates, BaseApiState>(state => state.apiState);

	useEffect(() => {
		dispatch(apiErrorClear());
		dispatch(setCurrentNewHireEnrollmentStep(NewHireEnrollmentStep.EMPLOYEE_RECORD));

	}, []);

	return (
		<PersonSearchContext.Provider value={PersonSearchKeys.NewHire}>
			{(OSCRRService.IsOSCRRWorking(apiState) ? <LoadingCircle /> : null)}
		<AnnualEnrollmentContext.Provider value={AnnualEnrollmentKey.newHireEnrollment}>
			<GenericStepper
				basePath={routeMatch.path}
				allSteps={[NewHireStep.PersonalInfo]}
				useCurrentStep={() => NewHireStep.PersonalInfo}
				setCurrentStep={null}
				progressItems={getNewParticipantStepItems(newHireProps)}
			/>
			<CreateNewParticipantForm 
				currentStep={ currentStep }
			/>
		</AnnualEnrollmentContext.Provider>
		{(OSCRRService.IsOSCRRWorking(apiState) ? <LoadingCircle /> : null)}
		</PersonSearchContext.Provider>
	);
}

export default NewParticipantRecord;